export const routes = [
    {
        // name: 'index',
        // path: ['/index.html','/natural'],
        // path: ['/', '/index.html','/natural' , '/en' , '/en/natural'],
        // page: 'natural'
    },
    {
        name: 'meals',
        path: ['/club-legado', '/maestros-parrilleros', '/'],
        page: 'meals'
    },
    {
        name: 'registroMeals',
        path: ['/club-legado', '/maestros-parrilleros', '/'],
        page: 'registroMeals'
    },
    {
        name: 'registroParrilla',
        path: ['/club-legado', '/maestros-parrilleros/postular'],
        page: 'registroParrilla'
    },
]
